import { memo } from 'react'
import { SxProps } from '@mui/material'
import { Box } from '@/components/Layout'
import { dotStyles as styles } from './Dot.style'
import { DotProps } from './Dot.types'

export const dotClasses = {
  dot: 'dot',
}

function Dot({ className = '', sx, light = false, ...otherProps }: DotProps) {
  return (
    <Box
      className={`${dotClasses.dot} ${className}`}
      sx={[styles.dotWrapper, light && styles.light, sx] as SxProps}
      {...otherProps}
    />
  )
}

export default memo(Dot)
